import React from "react";
import PageLayout from "../components/Layout/PageLayout";
import Aboutus from "../components/Sections/About Us";

export default function AboutPage() {
  return (
    <PageLayout
      path="/about"
      title="About Finechek (A) Systems | Laboratory Equipment Supplier"
      description="Learn about Finechek (A) Systems: our mission, commitment to quality, innovation and how we support laboratories with reliable diagnostic equipment and reagents."
    >
      <Aboutus />
    </PageLayout>
  );
}
